import { PathOptions } from "leaflet";

export const rodovias_federais = (feature: any): PathOptions => {
  return {
    color: "#FF0000",
    weight: 2,
    opacity: 1,
  };
};
